import { TOGGLE_EVENT_TYPE_FILTER_MENU } from './constants';

export function toggleEventTypeFilterMenu(value) {
  return {
    type: TOGGLE_EVENT_TYPE_FILTER_MENU,
    value,
  };
}
